var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"py-2"},[_vm._v(_vm._s(_vm.$t('formatNotSupported')))]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('returnToHomepage')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }